import tenantApiUrl from "../utils/tenantApiUrl";
import fetch from "../utils/mgFetch";

const getTenantEmployees = (token, DB_NAME) => {
    return fetch(`${tenantApiUrl(DB_NAME)}getallemployees/`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}

export default getTenantEmployees